export const OBJECT_TYPE = {
  LANDING_PAGE: '0-25',
  TASK: '0-27',
  FORM: '0-28',
  MARKETING_EMAIL: '0-29',
  AD_CAMPAIGN: '0-31',
  CAMPAIGN: '0-35',
  SITE_PAGE: '0-38',
  BLOG_POST: '0-39',
  CTA: '0-42',
  WORKFLOW: '0-44',
  SOCIAL_BROADCAST: '0-71',
  MARKETING_EVENT: '0-54'
};
export const OBJECT_TYPE_KEYS = Object.keys(OBJECT_TYPE);
export const OBJECT_TYPE_VALUES = Object.values(OBJECT_TYPE);